/**
 * Profile raster icon assets (copied from client-native/assets).
 * iOS uses PNGs, not emoji, for the stat row and analytics cards.
 */
import timerIcon from "@/assets/profile/timer.png";
import fireIcon from "@/assets/profile/fire.png";
import openBookIcon from "@/assets/profile/open-book.png";
import cloud1 from "@/assets/profile/cloud-1.png";
import cloud2 from "@/assets/profile/cloud-2.png";
import sunFace from "@/assets/profile/sunface.png";
import sunRays from "@/assets/profile/sunfull2.png";

export { timerIcon, fireIcon, openBookIcon, cloud1, cloud2, sunFace, sunRays };

/** Level icon URL for a given level (1..50), or undefined. */
const levelIconModules = import.meta.glob<string>(
  "../../assets/levels/*.png",
  { eager: true, import: "default", query: "?url" }
);

export function getLevelIconUrl(level: number): string | undefined {
  const padded = String(level).padStart(2, "0");
  const match = Object.entries(levelIconModules).find(([path]) =>
    path.includes(`/level-${padded}-`)
  );
  return match?.[1];
}
